/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { ClientNfsShareService } from '../client-nfs-share/client-nfs-share.service';
import { FrontTableClientNfsShareModule } from '../client-nfs-share/front-table-client-nfs-share/front-table-client-nfs-share.module';
import { NfsShareService } from '../nfs-share.service';
import { NfsShareStrService } from '../nfs-share-str.service';
import { CopyFromNfsShareSComponent } from './copy-from-nfs-share-s.component';

@NgModule({
    declarations: [CopyFromNfsShareSComponent],
    exports: [CopyFromNfsShareSComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        FrontTableClientNfsShareModule,
    ],
    providers: [
        NfsShareStrService,
        NfsShareService,
        ClientNfsShareService,
    ],
})
export class CopyFromNfsShareSModule { }
